import { BaseModel } from '../../../models/base-model'
import { CartItem } from '../cart-item'
import { Product } from '../product'

export class CartItemAssociation extends BaseModel {

  public purchasedCartItem: CartItem
  public associatedCartItem: CartItem
  public purchasedProduct: Product
  public associationType: number

  constructor() { super() }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/data/models/cart-item-association/cart-item-association.ts